type CollegeRegistrationWindow = {
  drive_start_date?: string | null;
  drive_end_date?: string | null;
};

export type RegistrationAvailabilityStatus =
  | "invalid"
  | "unscheduled"
  | "upcoming"
  | "closed"
  | "open";

interface RegistrationAvailabilityResult {
  status: RegistrationAvailabilityStatus;
  startDate: string | null;
  endDate: string | null;
}

export function getRegistrationAvailability(
  college: CollegeRegistrationWindow | null,
  currentDate: string | null
): RegistrationAvailabilityResult {
  if (!college) {
    return {
      status: "invalid",
      startDate: null,
      endDate: null,
    };
  }

  const startDate = college.drive_start_date ?? null;
  const endDate = college.drive_end_date ?? null;

  if (!startDate || !endDate) {
    return {
      status: "unscheduled",
      startDate,
      endDate,
    };
  }

  if (!currentDate) {
    return {
      status: "closed",
      startDate,
      endDate,
    };
  }

  if (currentDate < startDate) {
    return {
      status: "upcoming",
      startDate,
      endDate,
    };
  }

  if (currentDate > endDate) {
    return {
      status: "closed",
      startDate,
      endDate,
    };
  }

  return {
    status: "open",
    startDate,
    endDate,
  };
}

export function formatRegistrationDate(date: string) {
  return new Date(`${date}T00:00:00+05:30`).toLocaleDateString("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
